import React from 'react';
import { Grid, makeStyles, createStyles } from '@material-ui/core';

import { KeywordModel } from '../../Models/KeywordModel';
import { theme } from '../../theme';
import { EditAction } from '../enum/EditAction';
import { KeywordChip } from './KeywordChip';

interface IKeywordListForClientProps {
    selectedKeywords: KeywordModel | KeywordModel[],
    keywordList: KeywordModel[],
    searchTextFilter: string
    onSelectKeyword?: (keyword: KeywordModel) => void,
    onDeselectKeyword?: (keyword: KeywordModel) => void,
}

const useStyles = makeStyles(() => createStyles({
    keywordsComponents: {
        overflow: 'auto',
        maxHeight: '220px'
    }
}));


export function KeywordListForClient({
    selectedKeywords,
    keywordList,
    onSelectKeyword,
    onDeselectKeyword,
    searchTextFilter }: IKeywordListForClientProps) {

    const classes = useStyles();

    const getSelectedKeywordList = () => {

        if (Array.isArray(selectedKeywords)) {

            const currentKewyords: KeywordModel[] = selectedKeywords.filter(sk => sk.editAction != EditAction.DELETE);

            return (
                currentKewyords.map(keyword => 
                    <KeywordChip
                        key={ `chip-${keyword.description}-selected` }
                        keyword={ keyword }
                        selected={ true }
                        onDeselectKeyword={ onDeselectKeyword }/>
                )
            );
        }
        else if (selectedKeywords.description != ''){
            return (
                <KeywordChip
                    key={ `chip-${selectedKeywords.description}-selected` }
                    keyword={ selectedKeywords }
                    selected={ true }
                    onDeselectKeyword={ onDeselectKeyword }/>
            );
        }
    };

    const getNotSelectedKeywordList = () => {
        let filteredList: KeywordModel[] = [];
        
        if (searchTextFilter != '') {
            filteredList = keywordList.reduce((filtered: KeywordModel[], currentKewyord: KeywordModel) => {

                if (currentKewyord.description.toLowerCase().includes(searchTextFilter.toLowerCase()))
                    filtered.push(currentKewyord);

                return filtered;
            }, []);
        }
        else
            filteredList = [ ...keywordList];

        const renderList = filteredList.filter(keyword => {
            if (Array.isArray(selectedKeywords)) {
                return !selectedKeywords.some(sk => sk.description === keyword.description && sk.editAction != EditAction.DELETE);
            }
            else {
                return keyword.description !== selectedKeywords.description;
            }
        });

        if (renderList && renderList.length > 0) {
            return (
                renderList.map(keyword => 
                    <KeywordChip
                        key={ `chip-${keyword.description}-not-selected` }
                        keyword={ keyword }
                        selected={ false }
                        onSelectKeyword={ onSelectKeyword }/>)
            );
        }
    };

    return (
        <Grid container className={ classes.keywordsComponents }>
            <Grid item xs={12}>
                { getSelectedKeywordList() }
            </Grid>
            <Grid item xs={12} style={{ marginTop: theme.spacing(2) }}>
                { getNotSelectedKeywordList() }
            </Grid>
        </Grid>
    );
}